var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEyeOpen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ADB8FA5A-7434-480D-B035-B6AF4725A8B2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Details-Password",
    transform: "translate(-1245.000000, -574.000000)",
    fill: "#00B0F5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-Elements/Input/Active-Password",
    transform: "translate(878.000000, 557.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(367.001020, 17.016327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9336735,5.73061224 C17.8520408,2.20816327 14.072449,0 9.99897959,0 C5.9255102,0 2.14183673,2.20816327 0.0642857143,5.73061224 C-0.0214285714,5.85714286 -0.0214285714,6.02857143 0.0642857143,6.15510204 C2.14591837,9.67755102 5.9255102,11.8857143 9.99897959,11.8857143 C14.072449,11.8857143 17.8561224,9.67755102 19.9336735,6.15510204 C20.0193878,6.02857143 20.0193878,5.85714286 19.9336735,5.73061224 Z M9.99897959,11.0367347 C6.30510204,11.0367347 2.86428571,9.08571429 0.954081633,5.94285714 C2.86428571,2.8 6.30510204,0.848979592 9.99897959,0.848979592 C13.6928571,0.848979592 17.1336735,2.8 19.0438776,5.94285714 C17.1336735,9.08571429 13.6928571,11.0367347 9.99897959,11.0367347 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99897959,2.12244898 C7.87653061,2.12244898 6.17857143,3.82040816 6.17857143,5.94285714 C6.17857143,8.06530612 7.87653061,9.76326531 9.99897959,9.76326531 C12.1214286,9.76326531 13.8193878,8.06530612 13.8193878,5.94285714 C13.8193878,3.82040816 12.1214286,2.12244898 9.99897959,2.12244898 Z M9.99897959,8.91428571 C8.34183673,8.91428571 7.02755102,7.59591837 7.02755102,5.94285714 C7.02755102,4.28979592 8.34591837,2.97142857 9.99897959,2.97142857 C11.6520408,2.97142857 12.9704082,4.28979592 12.9704082,5.94285714 C12.9704082,7.59591837 11.6561224,8.91428571 9.99897959,8.91428571 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99897959,4.24489796 L9.99897959,5.09387755 C10.4642857,5.09387755 10.8479592,5.47755102 10.8479592,5.94285714 C10.8479592,6.40816327 10.4642857,6.79183673 9.99897959,6.79183673 C9.53367347,6.79183673 9.15,6.40816327 9.15,5.94285714 L8.30102041,5.94285714 C8.30102041,6.87755102 9.06428571,7.64081633 9.99897959,7.64081633 C10.9336735,7.64081633 11.6969388,6.87755102 11.6969388,5.94285714 C11.6969388,5.00816327 10.9336735,4.24489796 9.99897959,4.24489796 L9.99897959,4.24489796 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye_open.46e850d7.svg";
export { ForwardRef as ReactComponent };